import { type ComponentProps } from 'react';

export const RefreshIcon = (props: ComponentProps<'svg'>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M15.8791 15.0621C15.1512 16.2042 14.0359 17.0455 12.7377 17.4314C11.4396 17.8173 10.0458 17.722 8.81223 17.1631C7.57867 16.6041 6.58815 15.6189 6.02252 14.3883C5.45688 13.1578 5.35409 11.7646 5.73302 10.4643C6.11195 9.16413 6.94716 8.04425 8.08532 7.31027C9.22348 6.57629 10.5882 6.2775 11.9289 6.46874C13.2697 6.65999 14.4964 7.32843 15.384 8.35135C16.2716 9.37427 16.7603 10.683 16.7606 12.0373V13.3371"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2223 11.6046L16.4915 13.3354L14.7607 11.6046"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
